document.addEventListener("DOMContentLoaded", () => {
  const msg = document.querySelector(".utility-bar .announcement-bar__message");
  const original = msg?.querySelector("span");
  if (!msg || !original) return;

  if (msg.querySelector(".gds-marquee-track")) return;

  const track = document.createElement("span");
  track.className = "gds-marquee-track";

  const copy1 = original.cloneNode(true);
  const copy2 = original.cloneNode(true);
  copy2.setAttribute("aria-hidden", "true");

  track.appendChild(copy1);
  track.appendChild(copy2);

  msg.innerHTML = "";
  msg.appendChild(track);
});